import datapoints from './datapoints';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import folderStore from 'owa-folders';
import getFolderData from 'owa-mail-actions/lib/getFolderData';
import loadDumpster from './helpers/loadDumpster';
import onAfterSelectingNode from './helpers/onAfterSelectingNode';
import selectNodeInFolderForest from './selectNodeInFolderForest';
import { action, select } from 'satcheljs/lib/legacy';
import { addFrequentlyUsedFolder } from 'owa-mail-frequently-used-folders';
import { folderForestStore, getSelectedNode } from 'owa-mail-folder-forest-store';
import { getSelectedTableView, getViewFilterForTable } from 'owa-mail-list-store';
import { isFolderUnderMsg } from 'owa-folders';
import { onSelectFolderComplete } from 'owa-mail-actions/lib/mailListActions';
import { resetFocus } from 'owa-mail-focus-manager';
import { PRIMARY_DUMPSTER_DISTINGUISHED_ID, ARCHIVE_DUMPSTER_DISTINGUISHED_ID, PRIMARY_DELETED_ITEMS_DISTINGUISHED_ID, ARCHIVE_DELETED_ITEMS_DISTINGUISHED_ID, } from 'owa-folders';
/**
 * General select a folder
 * @param folderId the folderId
 * @param treeType that the folder belongs to, i.e MailFolder or Favorites
 * @param actionSource action that initiated the switch folder action
 * @return a promise that resolves when the select folder has completed
 */
var selectFolderInternal = action('selectFolderInternal', datapoints.switchMailFolderDatapoint)(function selectFolderInternal(folderId, treeType, previousFolderId, actionSource, folderNodeType) {
    var distinguishedFolderId;
    // This is for the router code path, e.g we show /inbox instead of the real folder name in the url
    // if it's a distinguished folder
    if (folderId) {
        var distinguishedFolderName = folderId;
        // The folderId is the name of a DistinguishedFolder. Grab the correct id.
        distinguishedFolderId = folderNameToId(distinguishedFolderName);
    }
    var folderIdToSelect = distinguishedFolderId ? distinguishedFolderId : folderId;
    var switchFolderPromise = selectNodeInFolderForest({
        id: folderIdToSelect,
        type: folderNodeType != null ? folderNodeType : 0 /* Folder */,
        treeType: treeType,
    }, actionSource);
    return switchFolderPromise;
});
var selectFolderActionName = 'selectFolder';
export { selectFolderActionName };
/**
 * Select a folder
 * @param folderId the folderId
 * @param treeType that the folder belongs to, i.e MailFolder or Favorites
 * @param actionSource action that initiated the switch folder action
 * @param state selected folder state
 */
export default action(selectFolderActionName)(select({
    selectedNode: function () { return folderForestStore.selectedNode; },
})(function selectFolder(folderId, treeType, actionSource, folderNodeType, state) {
    var previousFolderId = getSelectedNode().id;
    var folder = folderStore.folderTable.get(folderId);
    var selectFolderPromise = Promise.resolve();
    var tableView = getSelectedTableView();
    // On a page reload, the tableView is undefined initially. So, we need this check
    var viewFilter = tableView && getViewFilterForTable(tableView);
    var isNewFolderSameAsPreviousFolder = folderId == previousFolderId;
    if (isNewFolderSameAsPreviousFolder) {
        // Do not perform the rest of selecting folder logic when
        // user navigates to the node with the same id
        state.selectedNode.treeType = treeType;
    }
    // We need to reload the folder if folders are different or folders are same but viewFilter is not all
    if (!isNewFolderSameAsPreviousFolder || (viewFilter && viewFilter !== 'All')) {
        selectFolderPromise = selectFolderInternal(folderId, treeType, previousFolderId, actionSource, folderNodeType);
        var folderName = folderIdToName(folderId);
        // refresh single folder count and get folder permissions
        getFolderData(folderId);
        // Do not add folder to frequently used if it is inbox or dumspter or it is not in primary mailbox
        if (isFolderUnderMsg(folder) &&
            folderName !== 'inbox' &&
            folderName !== PRIMARY_DUMPSTER_DISTINGUISHED_ID) {
            addFrequentlyUsedFolder(folderId);
        }
        if (folderName === PRIMARY_DELETED_ITEMS_DISTINGUISHED_ID) {
            loadDumpster(PRIMARY_DUMPSTER_DISTINGUISHED_ID);
        }
        else if (folderName === ARCHIVE_DELETED_ITEMS_DISTINGUISHED_ID) {
            loadDumpster(ARCHIVE_DUMPSTER_DISTINGUISHED_ID);
        }
    }
    // Reset focus based on priority list when we switch
    // to a new table or select the same folder
    resetFocus();
    // Called after selecting same/different folder
    // #15945 - We should try to merge SelectFolder, SelectPersona, SelectGroup logic and move this method into a common place
    onAfterSelectingNode(actionSource);
    // Raise onSelectFolder complete action
    selectFolderPromise.then(function () {
        onSelectFolderComplete();
    });
}));
//# sourceMappingURL=selectFolder.js.map